<template>
  <tr :class="{ 'table-success': selected }">
    <td>
      <span v-tooltip.top.start="'Click to see booking\'s details'">
        <h3 class="mb-0">
          <a :href="'/send-freight/bookings/' + booking.id">{{ booking.id }}</a>
        </h3>
      </span>
      <small class="mb-0"> Ref: {{ booking.sender_ref }} </small>
      <p>
        <strong>Placed:</strong><br />
        {{ booking.placed_at }}
      </p>
      <div
        v-if="booking.status_id <= 3"
        class="form-check"
        @click="$emit('showConfirmModal')"
      >
        <input
          type="checkbox"
          :checked="pickedUpChecked"
          class="form-check-input"
        />
        <label class="form-check-label" for="picked-up">Picked up</label>
      </div>
    </td>
    <td>
      <strong>{{ booking.pickupLocation.data.name }}</strong
      ><br />
      {{
        booking.pickupLocation.data.address.data.street_number +
          " " +
          booking.pickupLocation.data.address.data.street_name
      }}
      <br />
      {{ booking.pickupLocation.data.address.data.suburb }} <br />
      {{ booking.pickupLocation.data.address.data.city }} <br />
      <p class="mb-0">
        <strong>After: </strong><br />
        {{ booking.pickup_at }}
      </p>
      <p v-if="booking.pickup_before">
        <strong>Before: </strong><br />
        {{ booking.pickup_before }}
      </p>
      <p
        v-if="
          booking.latestTruckAllocationFreightEvent && !booking.pickupMovement
        "
      >
        <strong>Allocated to truck: </strong><br />
        {{ allocatedTruckPlate }}
      </p>
      <p v-if="booking.pickupMovement">
        <strong>Picked up: </strong><br />
        {{ booking.pickupMovement.data.time }}
      </p>
    </td>
    <td>
      <strong>{{ booking.deliveryLocation.data.name }}</strong
      ><br />
      {{
        booking.deliveryLocation.data.address.data.street_number +
          " " +
          booking.deliveryLocation.data.address.data.street_name
      }}
      <br />
      {{ booking.deliveryLocation.data.address.data.suburb }} <br />
      {{ booking.deliveryLocation.data.address.data.city }} <br />
      <p class="mb-0">
        <strong>Deliver by: </strong><br />
        {{ booking.deliver_at }}
      </p>
      <p v-if="booking.eta">
        <strong>Revised ETA: </strong><br />
        {{ booking.eta }}
      </p>
      <a
        style="margin:10px auto"
        class="btn btn-success btn-sm btn-block"
        :href="'/send-freight/bookings/' + booking.id"
        >Track</a
      >
    </td>
    <td>
      <table class="table">
        <tr v-for="line in booking.lines.data" :key="line.id">
          <td>{{ line.quantity }}</td>
          <td>
            {{ line.packageType.data.name }}<br />
            <i>({{ line.goodsType.data.name }})</i>
          </td>
          <td>{{ Math.trunc(line.weight) }}Kgs</td>
          <td>{{ line.volume }}m<sup>3</sup></td>
        </tr>
        <tr>
          <td colspan="2"><strong>Total:</strong></td>
          <td>{{ Math.trunc(booking.weight) }}Kgs</td>
          <td>{{ booking.volume }}m<sup>3</sup></td>
        </tr>
        <tr v-if="booking.dg_classes">
          <td colspan="4">
            <strong>DG Classes:</strong> {{ booking.dg_classes }}
          </td>
        </tr>
      </table>
    </td>
    <td>
      <p style="display:inline-block">
        <strong>Carrier:</strong><br />

        <span v-if="booking.status_id >= 3">{{ booking.carrier }}</span>
        <span v-else>
          Pending&nbsp;
          <span
            v-tooltip:bottom="[
              '<h6>Why does it say pending?</h6> Because we\'re filling empty space on trucks around New Zealand it can\
                         take a little while for us to confirm exactly who the carrier will be.\
                         Your booking is 100% guaranteed at the price you booked at, as we have\
                         a vast network of carriers around the country',
              true
            ]"
          >
            <i class="far fa-info-circle"></i>
          </span>
        </span>
      </p>
      <p>
        <strong>Price:</strong><br />
        ${{ booking.price }}
      </p>
    </td>
    <td>
      <a
        v-if="booking.carrier !== 'Aramex'"
        style="margin-bottom:4px"
        class="btn btn-primary btn-sm btn-block"
        :href="'/send-freight/bookings/' + booking.id + '/all'"
        target="_blank"
        >All Files</a
      >
      <a
        style="margin-bottom:4px"
        class="btn btn-primary btn-sm btn-block"
        :href="'/send-freight/bookings/' + booking.id + '/consignment'"
        target="_blank"
        >Con note</a
      >
      <a
        style="margin-bottom:4px"
        class="btn btn-primary btn-sm btn-block"
        :href="'/send-freight/bookings/' + booking.id + '/address-label'"
        target="_blank"
        >Address label</a
      >
      <a
        v-if="booking.is_dg > 0"
        style="margin-bottom:4px"
        class="btn btn-primary btn-sm btn-block"
        :href="'/send-freight/bookings/' + booking.id + '/dgs'"
        target="_blank"
        >DGs</a
      >
      <a
        v-if="booking.has_pod"
        style="margin-bottom:4px"
        class="btn btn-primary btn-sm btn-block"
        :href="'/send-freight/bookings/' + booking.id + '/proof-of-delivery'"
        target="_blank"
        >Proof of delivery</a
      >
      <a
        v-if="booking.invoice_ready"
        style="margin-bottom:4px"
        class="btn btn-info btn-sm btn-block"
        :href="'/send-freight/bookings/' + booking.id + '/invoice'"
        target="_blank"
        >Invoice</a
      >
      <div class="text-center" v-else>
        <small class="text-center">Not invoiced yet</small>
      </div>
      <a
        style="margin-bottom:4px"
        v-if="booking.has_credit_note"
        class="btn btn-warning btn-sm btn-block"
        :href="'/send-freight/bookings/' + booking.id + '/credit-note'"
        target="_blank"
        >Credit note</a
      >
      <el-button
        style="margin-top:4px; width: 100%"
        type="warning"
        v-if="booking.carrier == 'Pending' && !remove"
        @click="cancel(booking)"
        :loading="saving"
        >{{ buttonText }}</el-button
      >
    </td>
  </tr>
</template>

<script>
import moment from "moment";

export default {
  name: "booking-item",
  props: ["booking", "selected", "pickedUpChecked", "user"],
  data() {
    return {
      date: moment(this.booking.cancel_time_left * 60000),
      cancel_or_request: true,
      loggedInUserId: window.Freighthub.user.id,
      saving: false,
      remove: false
    };
  },
  mounted() {
    setInterval(() => {
      if (this.date == 0 || this.date > 900000) {
        return (this.date = 0);
      }
      this.date = moment(this.date.subtract(1, "seconds"));
    }, 1000);
  },

  methods: {
    cancel(booking) {
      this.saving = true;
      if (this.cancel_or_request) {
        axios
          .get(booking.id + "/cancel")
          .then(response => {
            if (response.data == "Assigned") {
              this.$swal({
                title:
                  "Booking has already been assigned, please contact Freighthub if you still wish to cancel this booking!",
                type: "error",
                confirmButtonText: "Okay"
              });
            } else {
              this.$swal({
                title: "Booking cancelled!",
                type: "success",
                confirmButtonText: "Okay"
              });
              this.remove = true;
            }

            this.saving = false;
          })
          .catch(errors => {
            this.saving = false;
            Event.$emit("serverError");
          });
      } else {
        this.saving = true;
        this.$prompt("Please enter a reason for cancellation", {
          confirmButtonText: "Submit",
          cancelButtonText: "Cancel",
          inputErrorMessage: "Invalid input"
        })
          .then(({ value }) => {
            this.$intercom.boot({
              userId: this.loggedInUserId,
              name: this.user.name,
              email: this.user.email
            });
            this.saving = false;
            this.$intercom.showNewMessage(
              "Hi, I would like to cancel booking #" +
                booking.id +
                ". Reason: " +
                value
            );
          })
          .catch(() => {
            this.saving = false;
            this.$message({
              type: "info",
              message: "Input canceled"
            });
          });
      }
    },

    text() {
      if (this.date > 0 && this.date < 900000) {
        this.cancel_or_request = true;
        return "Cancel Booking (" + this.time + " left)";
      }
      this.cancel_or_request = false;
      return "Request Cancellation";
    }
  },
  computed: {
    allocatedTruckPlate: function() {
      return this.booking.latestTruckAllocationFreightEvent.data.truck_plate
        ? this.booking.latestTruckAllocationFreightEvent.data.truck_plate
        : "unknown";
    },
    time: function() {
      return this.date.format("mm:ss");
    },
    buttonText() {
      return this.text();
    }
  }
};
</script>
